module.exports = __webpack_public_path__ + "img/170190.0464a88f.png";